import { render, staticRenderFns } from "./SecondHandSales.vue?vue&type=template&id=390494ae&"
import script from "./SecondHandSales.vue?vue&type=script&lang=js&"
export * from "./SecondHandSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports